import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

// components
import Iconify from "../components/iconify";
// sections
import {
	fetchWeeklyVisitors,
	fetchNewWeeklyMembers,
	fetchMonthlyVisitors,
	fetchTotalMembers,
	fetchMonthlyVisitsGraph,
	fetchDietaryStats,
} from "../redux/dashboardSlice";
// sections
import {
	AppCurrentVisits,
	AppWebsiteVisits,
	AppWidgetSummary,
} from "../sections/@dashboard/app";
import { useSelector, useDispatch } from "react-redux";

export default function DashboardAppPage() {
	const theme = useTheme();
	const dispatch = useDispatch();

	const {
		weeklyVisitors,
		newWeeklyMembers,
		monthlyVisitors,
		totalMembers,
		monthlyVisitsGraph,
		dietaryStats,
		status,
	} = useSelector((state) => state.data.dashboard);

	const allDataLoaded
        = weeklyVisitors !== null
        && newWeeklyMembers !== null
        && monthlyVisitors !== null
        && totalMembers !== null
        && monthlyVisitsGraph !== null
        && dietaryStats !== null
        && status === "succeeded";

	// useEffect to dispatch fetches
	useEffect(() => {
		// Dispatch all fetch actions
		dispatch(fetchWeeklyVisitors());
		dispatch(fetchNewWeeklyMembers());
		dispatch(fetchMonthlyVisitors());
		dispatch(fetchTotalMembers());
		dispatch(fetchMonthlyVisitsGraph());
		dispatch(fetchDietaryStats());
	}, [dispatch]);


	const dietaryChartData = Array.isArray(dietaryStats)
		? dietaryStats.map((item) => ({
			label: item.dietary_name,
			value: Number(item.total_users),
		}))
		: [];

	const chartLabelsmonthlyVisitsGraph = Array.isArray(monthlyVisitsGraph)
		? monthlyVisitsGraph.map((d) =>
			new Date(d.month_start).toLocaleString("en-US", { month: "short" })
		)
		: [];

	const chartDatamonthlyVisitsGraph = Array.isArray(monthlyVisitsGraph)
		? [
			{
				name: "Visitors",
				data: monthlyVisitsGraph.map((d) => Number(d.member_visits)),
			},
		]
		: [
			{
				name: "Visitors",
				data: [],
			},
		];

	return !weeklyVisitors ? (
		<div>
			<Backdrop
				sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
				open={open}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
		</div>
	)
		:	(
			<>
				<Helmet>
					<title> Dashboard | Castlemilk Pantry </title>
				</Helmet>

				<Container maxWidth="xl">
					<Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
					</Typography>

					<Grid container spacing={3}>
						<Grid item xs={6} sm={6} md={4} lg={3}>
							<AppWidgetSummary
								title="Weekly visitors"
								total={weeklyVisitors ?? 0}
								icon={"ant-design:shop-filled"}
							/>
						</Grid>
						<Grid item xs={6} sm={6} md={4} lg={3}>
							<AppWidgetSummary
								title="New weekly members"
								total={newWeeklyMembers ?? 0}
								color="info"
								icon={"ant-design:skin-filled"}
							/>
						</Grid>
						<Grid item xs={6} sm={6} md={4} lg={3}>
							<AppWidgetSummary
								title="Monthly visitors"
								total={monthlyVisitors ?? 0}
								color="error"
								icon={"ant-design:android-filled"}
							/>
						</Grid>
						<Grid item xs={6} sm={6} md={4} lg={3}>
							<AppWidgetSummary
								title="Total Members"
								total={totalMembers ?? 0}
								color="warning"
								icon={"ant-design:skin-filled"}
							/>
						</Grid>
						{Array.isArray(monthlyVisitsGraph) && monthlyVisitsGraph.length > 0 && (
							<Grid item xs={12} md={6} lg={8}>
								<AppWebsiteVisits
									title="Monthly Visits"
									subheader=""
									chartLabels={chartLabelsmonthlyVisitsGraph}
									chartData={chartDatamonthlyVisitsGraph}
								/>
							</Grid>
						)}
						{Array.isArray(dietaryStats) && dietaryStats.length > 0 && (
							<Grid item xs={12} md={6} lg={4}>
								<AppCurrentVisits
									title="Dietary Requirements"
									chartData={dietaryChartData}
									chartColors={[
										theme.palette.primary.main,
										theme.palette.success.main,
										theme.palette.info.main,
										theme.palette.warning.main,
										theme.palette.error.main,
										theme.palette.secondary.main,
									]}
								/>
							</Grid>
						)}

					</Grid>
				</Container>
			</>
		);
}
